import { Address, Mobile, EmailBox, Telephone } from "../../../assets/icon";
import { ContactUsSideInput } from "../../../components";
import React, { useState, useEffect } from "react";
import { axiosReq } from "../../../commons/axiosReq";
const Detail = () => {
    const [contextData, setContextData] = useState();
    const [reCheck, setRecheck] = useState();
    const GetData = async () => {

        const contexData = await axiosReq("Admins/GetContext", "get");
        console.log(999)
        console.log(contexData)
        setContextData(contexData)


    }

    useEffect(() => {

        GetData();
    }, [reCheck]);
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "") {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
            // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
            //     updatedState[o] = true;


            //     setAllValuesError({ ...allValuesError, ...updatedState })
            //     result = false;
            // }

        }
        console.log(allValuesError)
        return result
    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const [allValues, setAllValues] = useState({
        Name: '',
        Email: '',
        Title: '',
        Text: '',


    });
    const [allValuesError, setAllValuesError] = useState({
        Name: false,
        Email: false,
        Title: false,
        Text: false,

    });
    const createContact = async () => {



        var res = allFull(allValues)
        console.log(res)
        if (res) {
            const dataUser = await axiosReq("Admins/CreateContact", "post", {
                Name: allValues.Name,
                Email: allValues.Email,
                Title: allValues.Title,
                Text: allValues.Text,

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)
                setAllValues({
                    Name: '',
                    Email: '',
                    Title: '',
                    Text: '',
            
            
                })
                // setShowModal(false)
                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");

            }
            else {
                console.log(allValuesError)
                // setEroor(dataUser?.data)
                alert(dataUser?.data);
            }
        }
        else {


            console.log(allValuesError)

        }
    }
    return (
        <>
            <div className="flex bg-transparent w-[100%] h-[610px] mb-40 justify-center -mt-80 e1440:flex-col-reverse e1440:items-center e1440:justify-start e1440:h-full md:px-10 md:c550:px-3">
                <div className="bg-white w-[600px] ml-[20px] shadow-white-shadow rounded-2xl p-[30px] flex flex-col items-center justify-start content-center md:my-2 e1440:w-[700px] e1440:ml-0 e1440:mt-[20px] e1440:md:w-[100%] ">
                    <p className="text-[28px] px-[20px] pt-[1px] mb-3 font-IRANYekanExtra text-mainColor2 xs:text-[24px]">با ما در تماس باشید</p>
                    <div className=""><div className="mb-[12px] w-[410px] c550:w-[340px] c550:xs:w-[290px]">
                        <ContactUsSideInput
                            ContactUs={true}
                            //   onBlur={blurHandler}
                            name="Name"
                            onChange={changeHandler}
                              value={allValues?.Name}
                            //   onInput={maxLengthCheck}
                            maxLength={100}
                            title={"نام  "}
                            placeHolder={"نام  "} /></div></div>
                    <div className=""><div className="mb-[12px] w-[410px] c550:w-[340px] c550:xs:w-[290px]">
                        <ContactUsSideInput
                            ContactUs={true}
                            //   onBlur={blurHandler}
                            name="Email"
                            onChange={changeHandler}
                              value={allValues?.Email}
                            //   onInput={maxLengthCheck}
                            maxLength={100}
                            title={"ایمیل  "}
                            placeHolder={"ایمیل  "} /></div></div>
                    <div className=""><div className="mb-[12px] w-[410px] c550:w-[340px] c550:xs:w-[290px]">
                        <ContactUsSideInput
                            ContactUs={true}
                            //   onBlur={blurHandler}
                            name="Title"
                            onChange={changeHandler}
                              value={allValues?.Title}
                            //   onInput={maxLengthCheck}
                            maxLength={100}
                            title={"عنوان "}
                            placeHolder={"عنوان "} /></div></div>
                    <div className="w-[410px] mb-[28px] c550:w-[340px] c550:xs:w-[290px]">
                        <p className="text-[18px] font-IRANYekanBold text-mainColor2 mb-[6px]">متن</p>
                        <textarea
                            name="Text"
                            onChange={changeHandler}
                            value={allValues?.Text}
                            // onInput={maxLengthCheck}
                            maxLength={100}
                            className="h-[140px] w-full focus:outline-lightGray border-[2px] border-borderGray text-[13px] font-IRANYekanNormal p-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="متن" />
                    </div>
                    <button onClick={() => createContact()} className="w-[150px] h-[42px] bg-nextColor text-white rounded-[5px] text-[18px] font-IRANYekanBold">ارسال پیام</button>
                </div>
                {
                    contextData ?
                        <div className="w-[700px] flex flex-wrap md:flex-col md:items-center md:w-[100%] ">
                            <div
                                className="bg-white w-[340px] ml-[20px] mb-[20px] shadow-white-shadow rounded-2xl p-[30px] flex flex-col items-center justify-center content-center md:w-[100%] md:ml-0">
                                <Telephone width="56px" height="56px" fill="#184548" />
                                <span className="font-IRANYekanExtra text-[25px] text-mainColor2 mt-8">
                                    شماره تماس
                                </span>
                                <span className="font-IRANYekanMedium text-lg text-black mt-10 text-center">
                                    {contextData[0].phoneNumber}
                                </span>
                                {/* <span className="font-IRANYekanMedium text-lg text-black text-center">
                            22546734 - 021
                        </span> */}
                            </div>
                            <div
                                className="bg-white w-[340px] mb-[20px] shadow-white-shadow rounded-2xl p-[30px] flex flex-col items-center justify-center content-center md:w-[100%]">
                                <EmailBox width="56px" height="56px" fill="#184548" />
                                <span className="font-IRANYekanExtra text-[25px] text-mainColor2 mt-8">
                                    پست الکترونیک
                                </span>
                                <span className="font-IRANYekanMedium text-lg text-black mt-10 text-center">
                                    {contextData[0].email}                    </span>
                                {/* <span className="font-IRANYekanMedium text-lg text-black text-center">
                            info@bordarnews.com
                        </span> */}
                            </div>
                            <div
                                className="bg-white w-[340px] ml-[20px] shadow-white-shadow rounded-2xl p-[30px] flex flex-col items-center justify-center content-center md:w-[100%] md:ml-0 md:mb-[20px]">
                                <Address width="56px" height="56px" fill="#184548" />
                                <span className="font-IRANYekanExtra text-[25px] text-mainColor2 mt-8">
                                    آدرس
                                </span>
                                <span className="font-IRANYekanMedium text-lg text-black mt-10 text-center">
                                    {contextData[0].address}
                                </span>

                            </div>
                            <div
                                className="bg-white w-[340px] shadow-white-shadow rounded-2xl p-[30px] flex flex-col items-center justify-center content-center md:w-[100%]">
                                <Mobile width="56px" height="56px" fill="#184548" />
                                <span className="font-IRANYekanExtra text-[25px] text-mainColor2 mt-8">
                                    تلفن همراه
                                </span>
                                <span className="font-IRANYekanMedium text-lg text-black mt-10 text-center">
                                    {contextData[0].mobile}
                                </span>
                                {/* <span className="font-IRANYekanMedium text-lg text-black text-center">
                           1452678 - 0912
                        </span> */}
                            </div>
                        </div>
                        : null
                }

            </div>
        </>
    )
}

export default Detail;